import * as yup from 'yup'

export const schema = yup.object().shape({
  startDate: yup.date()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr)),
  endDate: yup.date()
    .nullable()
    .transform((curr, orig) => (orig === '' ? null : curr))
    .when('startDate', (startDate, actualSchema) => {
      if (startDate) {
        const tempStartDate = new Date(startDate)
        const maxDate = new Date(tempStartDate.setMonth(startDate.getMonth() + 2))
        return actualSchema
          .min(startDate, 'A data final não pode ser menor do que a data inicial')
          .max(maxDate, 'A data final não pode ser maior que dois meses da data inicial')
      } return actualSchema
    }),
})
